import {
  Box,
  createStyles,
  makeStyles,
  Paper,
  Tab,
  Typography,
} from '@material-ui/core'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { useEffect, useRef, useState } from 'react'
import { Player } from '../types'
import {
  getTierTitle,
  sortPlayersByName,
  sortPlayersByPopularity,
} from '../utils/player'
import { NUM_TIERS } from '../utils/storage'
import PlayerResults from './PlayerResults'

interface Props {
  activeTierIndex: number
  availablePlayers: Player[]
  onSelect: (playerId: string) => void
}

const useStyles = makeStyles(() =>
  createStyles({
    panel: {
      padding: 0,
    },
  }),
)

type Filter = 'all' | 'popular'

const PlayerPicker = ({
  activeTierIndex,
  availablePlayers,
  onSelect,
}: Props) => {
  const classes = useStyles()
  const popularTabRef = useRef<HTMLDivElement>(null)
  const [tab, setTab] = useState<Filter>('popular')
  const allPlayers = sortPlayersByName(availablePlayers)
  const popularPlayers = sortPlayersByPopularity(availablePlayers).filter(
    ({ popularity }) =>
      popularity !== undefined && popularity < NUM_TIERS + 0.5,
  )

  useEffect(() => {
    // focus the popular tab initially
    popularTabRef.current?.focus()
  }, [])

  return (
    <Box>
      <Typography variant="h4" component="div" align="center" gutterBottom>
        Rank{' '}
        <Typography component="strong" variant="inherit" color="textSecondary">
          {getTierTitle(activeTierIndex)}
        </Typography>{' '}
        {activeTierIndex === 0 ? 'player' : 'players'}
      </Typography>

      {availablePlayers.length > 0 && (
        <TabContext value={tab}>
          <Paper square>
            <TabList
              onChange={(_, newTab) => setTab(newTab)}
              aria-label="Sort by"
              variant="fullWidth"
              indicatorColor="secondary"
              textColor="inherit"
            >
              <Tab label="Popular" value="popular" ref={popularTabRef} />
              <Tab label="All" value="all" />
            </TabList>
          </Paper>
          <TabPanel value="popular" classes={{ root: classes.panel }}>
            <PlayerResults
              group="popular"
              onSelect={onSelect}
              onSwitchGroup={setTab}
              players={popularPlayers}
            />
          </TabPanel>
          <TabPanel value="all" classes={{ root: classes.panel }}>
            <PlayerResults
              group="all"
              players={allPlayers}
              onSwitchGroup={setTab}
              onSelect={onSelect}
            />
          </TabPanel>
        </TabContext>
      )}
    </Box>
  )
}

export default PlayerPicker
